import React, { PureComponent } from 'react';

import Select from '@atlaskit/select';
import { gridSize } from '@atlaskit/theme';
import {
  getCloneCommand,
  CloneProtocol,
} from '@atlassian/bitkit-clone-controls';
import { CopyableTextFieldStateless } from '@atlassian/bitkit-copy';

import { Repository } from 'src/components/types';

import * as styles from './clone-command.style';

type Item = {
  value: string;
  label: string;
};

type ActionMeta = {
  removedValue?: Item;
  action:
    | 'select-option'
    | 'deselect-option'
    | 'remove-value'
    | 'pop-value'
    | 'set-value'
    | 'clear'
    | 'create-option';
};

const protocolItems: Item[] = ['https', 'ssh'].map(protocol => ({
  value: protocol,
  label: protocol.toUpperCase(),
}));

const getProtocolItem = (protocol: string) =>
  protocolItems.filter(item => item.value === protocol)[0];

type CloneCommandProps = {
  initialProtocol: CloneProtocol;
  repository: Repository;
};

type CloneCommandState = {
  protocol: CloneProtocol;
};

export default class CloneCommand extends PureComponent<
  CloneCommandProps,
  CloneCommandState
> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    initialProtocol: 'https',
  };

  state = {
    protocol: this.props.initialProtocol,
  };

  handleProtocolSelect = (selected: Item, { action }: ActionMeta) => {
    if (action === 'select-option') {
      this.setState({ protocol: selected.value as CloneProtocol });
    }
  };

  render() {
    const { repository } = this.props;
    const { protocol } = this.state;

    const cloneCommand = getCloneCommand(protocol, repository);
    const protocolItem = getProtocolItem(protocol);

    return (
      <styles.CloneCommand>
        <Select
          defaultValue={protocolItem}
          options={protocolItems}
          onChange={this.handleProtocolSelect}
          // min width to prevent truncating the protocol options
          styles={{
            // @ts-ignore TODO: fix noImplicitAny error here
            container: containerStyles => ({
              ...containerStyles,
              minWidth: gridSize() * 12,
            }),
          }}
        />
        <styles.CopyableCloneCommand>
          <CopyableTextFieldStateless value={cloneCommand || ''} />
        </styles.CopyableCloneCommand>
      </styles.CloneCommand>
    );
  }
}
